export default __webpack_public_path__ + "static/media/international_cat_disabled.c613d70f.png";